import CensorDialog from './src/index';
import CensorDialogComp from './src/main.vue'
import type { App } from 'vue'

CensorDialogComp.install = function (app: App<Element>): void {
 
}

export default CensorDialogComp;
export {
  CensorDialog
}
